import { useState } from 'react';
import styled from 'styled-components';
import PrimaryButton from 'components/atoms/buttons/PrimaryButton';
import BREAKPOINTS from 'lib/constants/breakpoints';
import { trackEvent } from 'lib/services/analytics';
import { Paragraph } from '@components/atoms/Typography';
import { useCreateLeadMutation } from '@graphql/generated';

const Form = styled.form`
  margin-top: 16px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    button {
      width: 100%;
      margin-top: 10px;
      height: 60px;
    }
  }
`;

const Input = styled.input`
  border: 1px solid #b7b7b7;
  padding: 10.5px 0 10.5px 15px;
  width: 300px;
  font-weight: bold;
  border-radius: 5px;
  vertical-align: top;
  font-size: 14px;
  margin-right: 10px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    width: 100%;
  }
`;

const SubscribeBlogForm = ({
  description,
  inputBackground = 'rgba(0, 0, 0, 0.5)',
  inputColor = '#fff',
  origin,
  metadata,
}: {
  description: string;
  inputBackground?: string;
  inputColor?: string;
  origin: 'blog' | 'post';
  metadata?: Record<string, any>;
}) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [{ fetching }, createLead] = useCreateLeadMutation();

  return (
    <Form
      onSubmit={async (ev) => {
        ev.preventDefault();

        if (fetching || submitted) return false;

        await createLead({
          email,
          origin,
          metadata,
        });

        trackEvent('subscribed to blog', { email, origin, metadata });

        setSubmitted(true);

        return false;
      }}
    >
      <Paragraph>{submitted ? 'Você está dentro ✅' : description}</Paragraph>
      <div style={{ marginTop: 16 }}>
        <Input
          type="email"
          required
          placeholder="SEU MELHOR EMAIL"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="email"
          readOnly={submitted}
          disabled={submitted}
          style={{ backgroundColor: inputBackground, color: inputColor }}
        />
        <PrimaryButton
          style={{ display: submitted ? 'none' : 'inline-block' }}
          pink
          isLoading={fetching}
        >
          Inscrever
        </PrimaryButton>
      </div>
    </Form>
  );
};

export default SubscribeBlogForm;
